import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal
      title="How to Play Username Wordle"
      isOpen={isOpen}
      handleClose={handleClose}
      isWide={true}
    >
      <div className="max-w-3xl mx-auto">
        <p className="text-gray-500 dark:text-gray-300 mb-3">
          The premise of Username Wordle is simple yet engaging. You have 10
          tries to guess the username, with the game providing valuable clues
          along the way. The rules are as follows:
        </p>
        <p className=" text-gray-500 dark:text-gray-300 mb-3">
          <b>Guess the Username:</b> For each guess, you'll input a sequence of
          characters that you believe could be the username. The game will then
          provide feedback on how close your guess was to the actual username.
        </p>
        <p className=" text-gray-500 dark:text-gray-300mb-3">
          <b>Tile Colors:</b> After each guess, the tiles will change color to
          indicate the accuracy of your input:
        </p>
        <p className=" text-gray-500 dark:text-gray-300">
          Green tiles represent letters that are in the correct position.
        </p>
        <p className="text-gray-500 dark:text-gray-300">
          Yellow tiles indicate letters that are in the username but in the
          wrong position.
        </p>
        <p className="text-gray-500 dark:text-gray-300">
          Gray tiles mean the letter is not part of the username.
        </p>
        <p className="text-gray-500 dark:text-gray-300 mb-3">
          <b>Revealed Characters:</b> As you progress through the game, certain
          characters in the username will be revealed, providing you with
          valuable clues to help narrow down your guesses.
        </p>
        <p className="text-gray-500 dark:text-gray-300 mb-3">
          <b>Platform Preference:</b> While Username Wordle can be played on
          various devices, the game is recommended to be played on a PC for the
          best experience.
        </p>
        <div className="flex justify-center mb-1 mt-4">
          <Cell
            isRevealing={true}
            isCompleted={true}
            value="T"
            status="correct"
          />
          <Cell value="R" />
          <Cell value="A" />
          <Cell value="N" />
          <Cell value="S" />
          <Cell value="F" />
          <Cell value="O" />
          <Cell value="R" />
          <Cell value="M" />
        </div>
        <p className=" text-gray-500 dark:text-gray-300">
          The character T is in the username and in the correct spot.
        </p>
        <div className="flex justify-center mb-1 mt-4">
          <Cell value="J" />
          <Cell value="E" />
          <Cell value="S" />
          <Cell value="S" />
          <Cell
            isRevealing={true}
            isCompleted={true}
            value="_"
            status="present"
          />
          <Cell value="L" />
          <Cell value="I" />
          <Cell value="K" />
          <Cell value="E" />
          <Cell
            isRevealing={true}
            isCompleted={true}
            value="_"
            status="present"
          />
          <Cell value="F" />
          <Cell value="O" />
          <Cell value="U" />
          <Cell value="R" />
        </div>
        <p className="text-gray-500 dark:text-gray-300">
          There are at least two underscores in the username, and both of the
          ones in the guess are in the wrong spot.
        </p>
        <div className="flex justify-center mb-1 mt-4">
          <Cell value="G" />
          <Cell value="O" />
          <Cell value="L" />
          <Cell value="D" />
          <Cell value="E" />
          <Cell value="N" />
          <Cell value="S" />
          <Cell value="H" />
          <Cell value="I" />
          <Cell value="N" />
          <Cell value="E" />
          <Cell
            isRevealing={true}
            isCompleted={true}
            value="9"
            status="absent"
          />
          <Cell value="7" />
        </div>
        <p className="text-gray-500 dark:text-gray-300">
          The character 9 is not in the username in any spot.
        </p>
      </div>
    </BaseModal>
  )
}
